import { ProfileAPIService } from './AxiosAPIService';
import {
  User,
  PatchUserRequest,
  PostUserRequest,
  UsersResponse,
  DeleteUserRequest,
} from '../types/Users';
import { logger } from './SharedService';

export const getUserById = async (fleetId: string, userId: string): Promise<User> => {
  logger.info('GET', 'REQUEST', 'getUserById', `/fleets/${fleetId}/users/${userId}`);

  const { data } = await ProfileAPIService.api.get<User>(`/fleets/${fleetId}/users/${userId}`);

  logger.info('GET', 'RESPONSE', 'getUserById', data);
  return data;
};

export const getUsers = async (fleetId: string, query: string): Promise<UsersResponse> => {
  logger.info('GET', 'REQUEST', 'getUsers', `/fleets/${fleetId}/users${query}`);

  const { data } = await ProfileAPIService.api.get<UsersResponse>(`/fleets/${fleetId}/users${query}`);

  logger.info('GET', 'RESPONSE', 'getUsers', data);
  return data;
};

export const getAdminUsers = async (query: string): Promise<UsersResponse> => {
  logger.info('GET', 'REQUEST', 'getAdminUsers', `/users${query}`);

  const { data } = await ProfileAPIService.api.get<UsersResponse>(`/users${query}`);

  logger.info('GET', 'RESPONSE', 'getAdminUsers', data);
  return data;
};

export const postUser = async (payload: PostUserRequest): Promise<User> => {
  const {
    fleetId, email, name, role, adminRequest,
  } = payload;
  const path = !adminRequest ? `/fleets/${fleetId}/users` : '/users';
  const requestData = !adminRequest ? {
    email, name, role,
  } : {
    email, name, role, fleetId,
  };

  logger.info('POST', 'REQUEST', 'postUser', path, payload);

  const { data } = await ProfileAPIService.api.post<User>(path, requestData);
  logger.info('POST', 'RESPONSE', 'postUser', data);
  return data;
};

export const patchUser = async (payload: PatchUserRequest): Promise<User> => {
  const {
    id, fleetId, name, role, adminRequest,
  } = payload;
  const path = !adminRequest ? `/fleets/${fleetId}/users/${id}` : `/users/${id}`;
  const requestData = !adminRequest ? {
    name, role,
  } : {
    name, role, fleetId,
  };

  logger.info('PATCH', 'REQUEST', 'patchUser', path, payload);

  const { data } = await ProfileAPIService.api.patch<User>(path, requestData)
    .catch((e) => Promise.reject(e.response.data));
  logger.info('PATCH', 'RESPONSE', 'patchUser', data);
  return data;
};

export const deleteUser = async (payload: DeleteUserRequest): Promise<User> => {
  const { fleetId, id, adminRequest } = payload;
  const path = !adminRequest ? `/fleets/${fleetId}/users/${id}` : `/users/${id}`;

  logger.info('DELETE', 'REQUEST', 'deleteUser', path, payload);

  const { data } = await ProfileAPIService.api.delete<User>(path);

  logger.info('DELETE', 'RESPONSE', 'deleteUser', data);

  return data;
};
